<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_4119_10409)">
    <rect width="40" height="40" rx="20" fill="#F8F8F8" />
    <circle cx="20" cy="16" r="8" fill="#D7D6D6" />
    <circle cx="20" cy="40" r="16" fill="#D7D6D6" />
  </g>
  <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#EBEBEB" />
  <defs>
    <clipPath id="clip0_4119_10409">
      <rect width="40" height="40" rx="20" fill="white" />
    </clipPath>
  </defs>
</svg>
